import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PageHeader from "./PageHeader";
import PageContent from "./PageContent";
import "./FacultiesDetails.css";
import data from "./Faculties.json";

export default function ProfessorProfile() {
  const [activeTab, setActiveTab] = useState("details");
  const { id } = useParams();
  const [facultyData, setFacultyData] = useState(null);

  const [getFac, setGetFac] = useState();

  useEffect(() => {
    const vlaue = data.find((val) => val.id === id);

    setGetFac(vlaue);
  }, [id]);

  const faculties = useSelector((state) => state.auth.staffs);

  // Bio data links
  // const bioData = [
  //   {
  //     id: 55,
  //     BioLink: "https://content.acetians.in/uploads/Manishkumarverma.pdf",
  //   },
  //   { id: 56, BioLink: "https://content.acetians.in/uploads/sunilkumar.pdf" },
  //   { id: 58, BioLink: "" },
  //   {
  //     id: 60,
  //     BioLink: "https://content.acetians.in/uploads/Anuradha%20Biodata%201.pdf",
  //   },
  //   { id: 62, BioLink: "" },
  //   { id: 63, BioLink: "" },
  //   { id: 65, BioLink: "https://content.acetians.in/uploads/Untitled.pdf" },
  //   { id: 66, BioLink: "" },
  //   { id: 67, BioLink: "" },
  //   { id: 68, BioLink: "" },
  //   { id: 107, BioLink: "" },
  //   { id: 108, BioLink: "" },
  //   { id: 109, BioLink: "" },
  // ];

  useEffect(() => {
    if (faculties && id) {
      const faculty = faculties.find((f) => f.id === parseInt(id));
      setFacultyData(faculty);
    }
  }, [faculties, id]);

  // const getBioLink = () => {
  //   const bioItem = bioData.find((item) => item.id === parseInt(id));
  //   return bioItem?.BioLink || "https://www.gdclalitpur.ac.in/";
  // };

  if (!facultyData) {
    return <div>Loading...</div>;
  }

  // Sample research papers data
  const researchPapers = [
    {
      id: 1,
      title: "Advanced Studies in Plant Biology",
      journal: "International Journal of Botany",
      year: 2023,
      authors: "Verma, M.K., Sharma, A., Singh, R.",
      link: "#",
    },
    {
      id: 2,
      title: "Ecological Impact of Urban Flora",
      journal: "Environmental Research Letters",
      year: 2022,
      authors: "Verma, M.K., Gupta, P., Kumar, S.",
      link: "#",
    },
    {
      id: 3,
      title: "Medicinal Properties of Himalayan Plants",
      journal: "Journal of Ethnopharmacology",
      year: 2021,
      authors: "Verma, M.K., Patel, N., Joshi, A.",
      link: "#",
    },
  ];

  return (
    <div>
      <PageHeader title={`${facultyData.name}`} />
      <PageContent
        elem={
          <div className="profile-container">
            {/* Main Content Container */}
            <div className="profile-main">
              {/* Left Section */}
              <div className="profile-left">
                {/* <h1 onClick={() => console.log("getFac", getFac)}>chec data</h1> */}
                <div className="profile-photo">
                  <img
                    src={
                      facultyData.image_link ||
                      "https://via.placeholder.com/150"
                    }
                    alt={facultyData.name}
                  />
                </div>
              </div>

              {/* Right Section */}
              <div className="profile-right">
                <div className="profile-info">
                  <h2>{getFac?.personalDetails?.name}</h2>
                  <p className="designation">
                    {getFac?.professionalDetails?.designation?.map((item) => (
                      <p>{item},</p>
                    ))}
                  </p>

                  <div className="info-section">
                    <p className="info-title">Educational Qualifications</p>
                    <p className="info-text">
                      {getFac?.qualificationDetails?.map((item) => (
                        <p>{item}</p>
                      ))}
                    </p>
                  </div>

                  <div className="info-section">
                    <p className="info-title">Department</p>
                    <p className="info-text">
                      {getFac?.professionalDetails?.department ||
                        "Not specified"}
                    </p>
                  </div>
                  <div className="info-section">
                    <p className="info-title">Specialization</p>
                    <p className="info-text">
                      {getFac?.professionalDetails?.specialization ||
                        "Not specified"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs Navigation */}
            <div className="tabs-navigation">
              <button
                className={`tab-button ${
                  activeTab === "details" ? "active" : ""
                }`}
                onClick={() => setActiveTab("details")}
              >
                Details
              </button>

              <button
                className={`tab-button ${activeTab === "bio" ? "active" : ""}`}
                onClick={() => setActiveTab("bio")}
              >
                Bio Data
              </button>

              <button
                className={`tab-button ${
                  activeTab === "research" ? "active" : ""
                }`}
                onClick={() => setActiveTab("research")}
              >
                Research
              </button>
            </div>

            <div className="tab-content">
              {/* Details Tab */}
              {activeTab === "details" && (
                <div className="profile-details">
                  <div className="detail-row ">
                    <span className="label">Email</span>
                    <span className="value">
                      {getFac?.personalDetails?.email || "Not available"}
                    </span>
                  </div>
                  <div className="detail-row alt">
                    <span className="label">Phone</span>
                    <span className="value">
                      {getFac?.personalDetails?.Phone || "Not available"}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Teaching Experience</span>
                    <span className="value">
                      {getFac?.professionalDetails?.teachingExperience} Years
                    </span>
                  </div>

                  <div className="detail-row alt">
                    <span className="label">Research Experience</span>
                    <span className="value">–</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">Training Course</span>
                    <span className="value">–</span>
                  </div>

                  <div className="detail-row alt">
                    <span className="label">No of Research Project as PI</span>
                    <span className="value">–</span>
                  </div>

                  <div className="detail-row">
                    <span className="label">No of Research publication</span>
                    <span className="value">–</span>
                  </div>

                  <div className="detail-row alt">
                    <span className="label">Research Guidance</span>
                    <span className="value">–</span>
                  </div>
                </div>
              )}

              {/* Research Tab */}
              {activeTab === "research" && (
                <div>
                  {getFac?.research_papers?.length > 0 && (
                    <div className="research-content">
                      <h3 className="research-title">Research Publications</h3>
                      <div className="research-papers">
                        <div>
                          {getFac?.research_papers?.map((item) => (
                            <div key={item} className="paper-card">
                              <div className="paper-header">
                                <h4 className="paper-title">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.title,
                                    }}
                                  />
                                </h4>
                              </div>

                              {item.link && (
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={item.link}
                                  className="paper-link"
                                >
                                  View
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {getFac?.books?.length > 0 && (
                    <div className="research-content">
                      <h3 className="research-title">Books</h3>
                      <div className="research-papers">
                        <div>
                          {getFac?.books?.map((item) => (
                            <div key={item} className="paper-card">
                              <div className="paper-header">
                                <h4 className="paper-title">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.title,
                                    }}
                                  />
                                </h4>
                              </div>

                              {item.link && (
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={item.link}
                                  className="paper-link"
                                >
                                  View
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {getFac?.patents?.length > 0 && (
                    <div className="research-content">
                      <h3 className="research-title">patents</h3>
                      <div className="research-papers">
                        <div>
                          {getFac?.patents?.map((item) => (
                            <div key={item} className="paper-card">
                              <div className="paper-header">
                                <h4 className="paper-title">
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.title,
                                    }}
                                  />
                                </h4>
                              </div>

                              {item.link && (
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={item?.link}
                                  className="paper-link"
                                >
                                  View
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {getFac?.book_chapters?.length > 0 && (
                    <div className="research-content">
                      <h3 className="research-title">Book Chapters</h3>
                      <div className="research-papers">
                        <div>
                          {getFac.book_chapters.map((item) => (
                            <div key={item} className="paper-card">
                              <div className="paper-header">
                                <h4 className="paper-title">
                                  {" "}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.title,
                                    }}
                                  />
                                </h4>
                              </div>

                              {item.link && (
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={item?.link}
                                  className="paper-link"
                                >
                                  View
                                </a>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {activeTab === "bio" && (
                <div className="bio-content">
                  <h3 className="bio-title">Professional Biography</h3>
                  <div className="bio-sections">
                    <div className="bio-section">
                      <h4>Academic Background</h4>

                      {getFac?.about.length > 0 && (
                        <div className="bio-section">
                          {getFac?.about.map((text) => (
                            // <p>{text}</p>
                            <p
                              style={{ marginBottom: "3px" }}
                              dangerouslySetInnerHTML={{
                                __html: text,
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "download" && (
                <div className="download-content">
                  <h3 className="download-title">Download Research Papers</h3>
                  <div className="download-section">
                    <p className="download-description">
                      Access the complete collection of research publications by{" "}
                      {facultyData.name}. All papers are available in PDF format
                      for academic and research purposes.
                    </p>

                    <div className="download-options">
                      <div className="download-card">
                        <h4>Individual Papers</h4>
                        <p>Select and download specific research papers</p>
                        <div className="paper-list">
                          {researchPapers.map((paper) => (
                            <div key={paper.id} className="download-item">
                              <span>
                                {paper.title} ({paper.year})
                              </span>
                              <button className="download-button secondary">
                                Download PDF
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
}
